import { IDonor } from "../donor";
import { IRecipient } from "../recipient";
import { IOneWay } from './oneway';

export interface IMatchRunPosition {
    parent: IMatchRunPosition,
    donorId: number,
    recipientId: number,
    oneWayId: number,
    distance: number,
    hasChild: boolean,
    donor: IDonor,
    recipient: IRecipient,
    oneWay: IOneWay
}